import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-charts-12',
  templateUrl: './12.component.html',
})
export class VbChart12Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
